const defaultState = {
	id:"",
    shopId:"",
    name:"",
    displayName:"",
    email:"",
    phone:"1",
    storeId:"" ,
    personId:"" ,
    inboxId:"" 
};
export const person = (state = defaultState, action) => {
    switch (action.type) {
        default:
            return state;
    }
}